import { render, staticRenderFns } from "./TabMegaMenu.vue?vue&type=template&id=e7f8978c&scoped=true&"
import script from "./TabMegaMenu.vue?vue&type=script&lang=js&"
export * from "./TabMegaMenu.vue?vue&type=script&lang=js&"
import style0 from "./TabMegaMenu.vue?vue&type=style&index=0&id=e7f8978c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f8978c",
  null
  
)

export default component.exports